import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import UserProfile from "cruds/user-profile";
import RoleManagement from "cruds/role-managament";
import UserManagement from "cruds/user-management";
import PersonIcon from '@mui/icons-material/Person';
import VideoCallIcon from "@mui/icons-material/VideoCall";
import BusinessIcon from "@mui/icons-material/Business";
import PublicIcon from "@mui/icons-material/Public";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import Icon from "@mui/material/Icon";
import ShipmentTable from "./layouts/ecommerce/products/new-product/Shipment/ShipmentTable";
import CreateShipment from "./layouts/ecommerce/products/new-product/Shipment/CreateShipment";
import Consolidation from "./layouts/ecommerce/products/new-product/Shipment/Consolidation";
import ConnectMBL from "./layouts/ecommerce/products/new-product/Shipment/ConnectMBL";
import RoadShipmentAnalyticsDashboard from "./layouts/ecommerce/products/new-product/Shipment/RoadDashboard";
import CreateQuotingTool from "./layouts/ecommerce/products/new-product/QuotingTool/CreateQuotingTool";
import QuotingToolTable from "./layouts/ecommerce/products/new-product/QuotingTool/QuotingToolTable";
import CreateCustomer from "./layouts/ecommerce/products/new-product/crm/customer/CreateCustomer";
import CustomerTable from "./layouts/ecommerce/products/new-product/crm/customer/CustomerTable";
import CreateSpotQuotingTool from "./layouts/ecommerce/products/new-product/Spot Quoting Tool/CreateSpotQuotingTool";
import SpotQuotingToolTable from "./layouts/ecommerce/products/new-product/Spot Quoting Tool/SpotQuotingToolTable";
import CreateServiceProvider from "./layouts/ecommerce/products/new-product/crm/Service Provider/CreateServiceProvider";
import ServiceProviderTable from "./layouts/ecommerce/products/new-product/crm/Service Provider/ServiceProviderTable";
import RoadDashboard from "layouts/dashboards/analytics";
import GlobalAgentTable from "./layouts/ecommerce/products/new-product/crm/Global Agent/GlobalAgentTable";
import CreateGlobalAgent from "./layouts/ecommerce/products/new-product/crm/Global Agent/CreateGlobalAgent";
import CreateMeeting from "./layouts/ecommerce/products/new-product/crm/meeting/CreateMeeting";
import MeetingTable from "./layouts/ecommerce/products/new-product/crm/meeting/MeetingTable";
import OpportunityTable from "./layouts/ecommerce/products/new-product/crm/opportunity/OpportunityTable";
import CreateOpportunity from "./layouts/ecommerce/products/new-product/crm/opportunity/CreateOpportunity";
import DashboardTabs from "./layouts/ecommerce/products/new-product/crm/opportunity/DashboardTabs";
import Logout from "./auth/logout";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import CreateStrategy from "./layouts/ecommerce/products/new-product/crm/strategy/CreateStrategy";
import StrategyTable from "./layouts/ecommerce/products/new-product/crm/strategy/StrategyTable";
import ListAltIcon from '@mui/icons-material/ListAlt';
import TargetTable from "./layouts/ecommerce/products/new-product/crm/target/TargetTable";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import CreateCompetitor from "./layouts/ecommerce/products/new-product/crm/competitor/CreateCompetitor";
import CompetitorTable from "./layouts/ecommerce/products/new-product/crm/competitor/CompetitorTable";
import AppsIcon from '@mui/icons-material/Apps';
import AddBoxIcon from '@mui/icons-material/AddBox';
import ListIcon from '@mui/icons-material/List';
import DashboardIcon from '@mui/icons-material/Dashboard';
import EventNoteIcon from '@mui/icons-material/EventNote';
import CalendarViewDayIcon from '@mui/icons-material/CalendarViewDay';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import TimelineIcon from '@mui/icons-material/Timeline';
import RouteIcon from "@mui/icons-material/Route";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import ProspectListTable from "./layouts/ecommerce/products/new-product/crm/strategy/ProspectListTable";
import SalesPipeline from "./layouts/ecommerce/products/new-product/crm/opportunity/SalesPipeline";
import WeeklyShippingTable from "./layouts/ecommerce/products/new-product/Shipment/WeeklyShippingTable";
import CreateWeeklyShipping from "./layouts/ecommerce/products/new-product/Shipment/CreateWeeklyShipping";
import Certificates from "./layouts/pages/certificates";
import CertificateDetails from "./layouts/pages/certificates/details";
import BankDetails from "./layouts/ecommerce/products/new-product/finance/BankDetails";
import GlobalAgentDashboard from "./layouts/ecommerce/products/new-product/crm/Global Agent/GlobalAgentDashboard";
import Rfq from "./layouts/ecommerce/products/new-product/crm/rfq/Rfq";
import RfqDashboard from "./layouts/ecommerce/products/new-product/crm/rfq/RfqDashboard";
import InvoiceDetails from "./layouts/ecommerce/products/new-product/crm/invoice/InvoiceDetails";
import ServiceProviderDashboard from "./layouts/ecommerce/products/new-product/crm/Service Provider/ServiceProviderDashboard";
import QuotingDashboard from "./layouts/ecommerce/products/new-product/QuotingTool/QuotingDashboard";
import CreateSalesLead from "./layouts/ecommerce/products/new-product/crm/salesLead/CreateSalesLead";
import SalesLeadTable from "./layouts/ecommerce/products/new-product/crm/salesLead/SalesLeadTable";
import SalesLeadDashboard from "./layouts/ecommerce/products/new-product/crm/salesLead/SalesLeadDashboard";
import CreateOceanShipment from "./layouts/ecommerce/products/new-product/OceanTMS/CreateOceanShipment";
import OceanShipmentTable from "./layouts/ecommerce/products/new-product/OceanTMS/OceanShipmentTable";
import OceanConsolidation from "./layouts/ecommerce/products/new-product/OceanTMS/OceanConsolidation";
import OceanShipmentAnalyticsDashboard from "./layouts/ecommerce/products/new-product/OceanTMS/OceanDashboard";
import OceanShipmentStatus from "./layouts/ecommerce/products/new-product/OceanTMS/OceanShipmentStatus";
import AirShipmentTable from "./layouts/ecommerce/products/new-product/AirTMS/AirShipmentTable";
import CreateAirShipment from "./layouts/ecommerce/products/new-product/AirTMS/CreateAirShipment";
import AirConsolidation from "./layouts/ecommerce/products/new-product/AirTMS/AirConsolidation";
import AirShipmentAnalyticsDashboard from "./layouts/ecommerce/products/new-product/AirTMS/AirDashboard";
import AnnualLeaveForm from "./layouts/ecommerce/products/new-product/AnnualLeaveForm/AnnualLeaveForm";
import AnnualLeaveList from "./layouts/ecommerce/products/new-product/AnnualLeaveForm/AnnualLeaveList";
import FinanceDashboard, {
  FinanceJobs,
  CustomerInvoices,
  Collections,
  SupplierCosts, SupplierInvoices, Receivables, Payables,
  IncomingInvoices,
} from "./layouts/ecommerce/products/new-product/crm/invoice/finance";
import CreateManualInvoice from "./layouts/ecommerce/products/new-product/crm/invoice/finance/Manual-Invoice";
import CompanyCash from "./layouts/ecommerce/products/new-product/finance/CompanyCash";
import CreditCards from "./layouts/ecommerce/products/new-product/finance/CreditCard";
import PosAccounts from "./layouts/ecommerce/products/new-product/finance/PostAccount";
import Cheques from "./layouts/ecommerce/products/new-product/finance/Cheques";
import PromissoryNotes from "./layouts/ecommerce/products/new-product/finance/PromissoryNotes";
import Reconciliations from "./layouts/ecommerce/products/new-product/crm/invoice/finance/Reconciliation";

const routes = [
  {
    type: "collapse",
    name: "Bruce Mars",
    key: "user-name",
    icon: <PersonIcon fontSize="medium" />,
    collapse: [
      /*  {
          name: "My Profile",
          key: "profile-overview",
          route: "/pages/profile/profile-overview",
          component: <ProfileOverview />,
        },
        {
          name: "Settings",
          key: "settings",
          route: "/pages/account/settings",
          component: <Settings />,
        },*/
      {
        key: "logout",
        name: "Logout",
        icon: <Icon>logout</Icon>,
        route: "/auth/logout",
        component: <Logout />,
        noAuth: true,
      },
    ],
  },
  {
    type: "collapse",
    name: "Company Policy",
    key: "company-policy",
    icon: <Icon fontSize="medium">policy</Icon>,
    collapse: [
      {
        name: "Human Resources",
        key: "human-resources",
        collapse: [
          {
            name: "Create Annual Leave",
            key: "create-annual-leave",
            route: "/annual-leave/create",
            component: <AnnualLeaveForm />,
          },
          {
            name: "Annual Leave List",
            key: "annual-leave-list",
            route: "/annual-leave/list",
            component: <AnnualLeaveList />,
          },
        ],
      },
      {
        name: "Certificates",
        key: "certificates",
        collapse: [
          {
            name: "Certificates",
            key: "certificates-list",
            route: "/certificates",
            component: <Certificates />,
          },
        ],
      },
    ],
  },


  {
    name: "Certificate Details",
    key: "certificate-details",
    route: "/certificates/details",
    component: <CertificateDetails />,
    noCollapse: true,
    noAuth: true,
  },

  {
    name: "General Dashboard",
    key: "general-dashboard",
    route: "/dashboards/analytics",
    component: <RoadDashboard />,
    noCollapse: true,
  },

/*
  {
    type: "collapse",
    name: "Dashboards",
    key: "dashboards",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    collapse: [
      {
        name: "KPI Dashboard",
        key: "kpi-dashboard",
        route: "/dashboards/reports",
        component: <ReportDashboard />,
      },
    ],
  },
*/

  {
    type: "collapse",
    name: "User Management",
    key: "react-nodejs",
    icon: <ManageAccountsIcon fontSize="medium" />,
    collapse: [
      {
        name: "User Profile",
        key: "user-profile",
        route: "/user/user-profile",
        component: <UserProfile />,
      },
      {
        name: "User List",
        key: "user-management",
        route: "/user/user-management",
        component: <UserManagement />,
        type: "users",
      },
      {
        name: "Authorization",
        key: "role-management",
        route: "/user/role-management",
        component: <RoleManagement />,
        type: "roles",
      },
    ],
  },

  {
    type: "collapse",
    name: "Finance",
    key: "finance",
    icon: <Icon fontSize="medium">account_balance</Icon>,
    collapse: [
      {
        name: "Overview",
        key: "finance-overview",
        collapse: [
          {
            name: "Dashboard",
            key: "finance-dashboard",
            route: "/invoice/finance",
            component: <FinanceDashboard />,
          },
          {
            name: "Finance Jobs",
            key: "finance-jobs",
            route: "/invoice/finance/jobs",
            component: <FinanceJobs />,
          },
        ],
      },

      {
        name: "Invoicing",
        key: "finance-invoicing",
        collapse: [
          {
            name: "Customer Invoices",
            key: "customer-invoices",
            route: "/invoice/finance/customer-invoices",
            component: <CustomerInvoices />,
          },
          {
            name: "Supplier Invoices",
            key: "supplier-invoices",
            route: "/invoice/finance/supplier-invoices",
            component: <SupplierInvoices />,
          },
          {
            name: "Incoming Invoices",
            key: "incoming-invoices",
            route: "/invoice/finance/incoming-invoices",
            component: <IncomingInvoices />,
          },
          {
            name: "Manual Invoices",
            key: "create-manual-invoice",
            route: "/invoice/finance/manual-invoices/new",
            component: <CreateManualInvoice />,
          },
        ],
      },

      {
        name: "Receivable",
        key: "accounts-receivable",
        collapse: [
          {
            name: "Receivables",
            key: "receivables",
            route: "/invoice/finance/receivables",
            component: <Receivables />,
          },
          {
            name: "Collections",
            key: "collections",
            route: "/invoice/finance/collections",
            component: <Collections />,
          },
        ],
      },

      {
        name: "Reconciliation",
        key: "finance-reconciliation",
        collapse: [
          {
            name: "Reconciliations",
            key: "reconciliations",
            route: "/invoice/finance/reconciliations",
            component: <Reconciliations />,
          },
        ],
      },

      {
        name: "Payable",
        key: "accounts-payable",
        collapse: [
          {
            name: "Supplier Costs",
            key: "supplier-costs",
            route: "/invoice/finance/supplier-costs",
            component: <SupplierCosts />,
          },
          {
            name: "Payables",
            key: "payables",
            route: "/invoice/finance/payables",
            component: <Payables />,
          },
        ],
      },

      {
        name: "Financial Records",
        key: "finance-treasury-reporting",
        collapse: [
          {
            name: "Bank Accounts",
            key: "finance-bank-accounts",
            route: "/finance/bank-accounts",
            component: <BankDetails />,
          },
          {
            name: "Company Cash",
            key: "company-cash",
            route: "/finance/company-cash",
            component: <CompanyCash />,
          },
          {
            name: "Credit Cards",
            key: "finance-credit-cards",
            route: "/finance/treasury/credit-cards",
            component: <CreditCards />,
          },
          {
            name: "POS Accounts",
            key: "finance-pos-accounts",
            route: "/finance/treasury/pos-accounts",
            component: <PosAccounts />,
          },
          {
            name: "Cheques",
            key: "finance-cheques",
            route: "/finance/treasury/cheques",
            component: <Cheques />,
          },
          {
            name: "Promissory Notes",
            key: "finance-promissory-notes",
            route: "/finance/treasury/promissory-notes",
            component: <PromissoryNotes />,
          },
          {
            name: "Invoice Records",
            key: "invoice-records",
            route: "/finance/invoices",
            component: <InvoiceDetails />,
          },
        ],
      },

      {
        name: "Accounts",
        key: "finance-customers",
        collapse: [
          {
            name: "Create Account",
            key: "create-customer",
            route: "/customer/create-customer/details",
            component: <CreateCustomer />,
          },
          {
            name: "Account List",
            key: "customer-tables",
            route: "/customer/customer-tables/details",
            component: <CustomerTable />,
          },
        ],
      },
    ],
  },

  {
    type: "collapse",
    name: "TMS",
    key: "shipping-files",
    icon: <RouteIcon fontSize="medium" />,

    collapse: [
      {
        type: "collapse",
        name: "Road",
        key: "shipping-road",
        icon: <Icon fontSize="medium">local_shipping</Icon>,
        collapse: [
          {
            name: "Create Shipment",
            key: "shipment-details",
            route: "/shipping-order/create-shipment/details",
            component: <CreateShipment />,
          },
          {
            name: "Shipment Tables",
            key: "shipment-tables",
            route: "/shipping-order/shipment-tables/details",
            component: <ShipmentTable />,
          },
          {
            name: "Consolidation",
            key: "shipment-consolidation",
            route: "/shipping-order/shipment-consolidation/consolidation",
            component: <Consolidation />,
          },
          {
            name: "Create Weekly Plan",
            key: "weekly-shipment-details",
            route: "/weekly-shipping-order/create-weekly-shipment/details",
            component: <CreateWeeklyShipping />,
          },
          {
            name: "Weekly Plan",
            key: "weekly-shipment-tables",
            route: "/weekly-shipping-order/weekly-shipment-tables/details",
            component: <WeeklyShippingTable />,
          },
          {
            name: "Road Analytics",
            key: "road-analytics",
            route: "/shipping-order/road-analytics/details",
            component: <RoadShipmentAnalyticsDashboard />,
          }
        ],
      },
      {
        type: "collapse",
        name: "Ocean",
        key: "shipping-ocean",
        icon: <Icon fontSize="medium">local_shipping</Icon>,
        collapse: [
          {
            name: "Create Shipment",
            key: "ocean-shipment-details",
            route: "/shipping-order/create-ocean-shipment/details",
            component: <CreateOceanShipment />,
          },
          {
            name: "Shipment Tables",
            key: "ocean-shipment-tables",
            route: "/ocean-shipping-order/shipment-tables/details",
            component: <OceanShipmentTable />,
          },
          {
            name: "Consolidation",
            key: "ocean-consolidation",
            route: "/ocean-shipping-order/shipment-consolidation/consolidation",
            component: <OceanConsolidation />,
          },
          {
            name: "Shipment Status",
            key: "ocean-shipment-status",
            route: "/ocean-shipping-order/shipment-status/details",
            component: <OceanShipmentStatus />,
          },
          {
            name: "Ocean Analytics",
            key: "ocean-analytics",
            route: "/ocean-shipping-order/ocean-analytics/details",
            component: <OceanShipmentAnalyticsDashboard />,
          },
        ],
      },
      {
        type: "collapse",
        name: "Air",
        key: "shipping-air",
        icon: <Icon fontSize="medium">local_shipping</Icon>,
        collapse: [
          {
            name: "Create Shipment",
            key: "air-shipment-details",
            route: "/shipping-order/create-air-shipment/details",
            component: <CreateAirShipment />,
          },
          {
            name: "Shipment Tables",
            key: "air-shipment-tables",
            route: "/air-shipping-order/shipment-tables/details",
            component: <AirShipmentTable />,
          },
          {
            name: "Consolidation",
            key: "air-consolidation",
            route: "/air-shipping-order/shipment-consolidation/consolidation",
            component: <AirConsolidation />,
          },
          {
            name: "Air Analytics",
            key: "air-analytics",
            route: "/air-shipping-order/air-analytics/details",
            component: <AirShipmentAnalyticsDashboard />,
          },
        ],
      },
    ],
  },
  {
    type: 'collapse',
    name: 'CRM',
    key: 'crm',
    icon: <AppsIcon fontSize="medium" />,
    collapse: [
      {
        type: 'collapse',
        name: 'Sales Dashboard',
        key: 'sales-dashboard',
        icon: <ListAltIcon fontSize="medium" />,
        collapse: [
          {
            type: 'item',
            name: 'Dashboard',
            key: 'opportunity-dashboard',
            route: '/sales-dashboard/dashboard',
            icon: <DashboardIcon fontSize="small" />,
            component: <DashboardTabs />,
          },
          {
            type: 'item',
            name: 'Sales Pipeline',
            key: 'opportunity-tables',
            route: '/sales-pipeline/sales-pipeline-tables/details',
            icon: <TimelineIcon fontSize="small" />,
            component: <SalesPipeline />,
          },
        ],
      },

      {
        type: 'collapse',
        name: 'Sales Strategies',
        key: 'strategy',
        icon: <TrendingUpIcon fontSize="medium" />,
        collapse: [
          {
            type: 'item',
            name: 'Create Strategy',
            key: 'create-strategy',
            route: '/strategy/create-strategy/details',
            icon: <AddBoxIcon fontSize="small" />,
            component: <CreateStrategy />,
          },
          {
            type: 'item',
            name: 'Sales Strategy List',
            key: 'strategy-tables',
            route: '/strategy/strategy-tables/details',
            icon: <ListIcon fontSize="small" />,
            component: <StrategyTable />,
          },
        ],
      },
      {
        type: 'collapse',
        name: 'Target Accounts',
        key: 'target',
        icon: <ListAltIcon fontSize="medium" />,
        collapse: [
          {
            type: 'item',
            name: 'Strategic Customer List',
            key: 'target-tables',
            route: '/target/target-tables/details',
            icon: <ListIcon fontSize="small" />,
            component: <TargetTable />,
          },
          {
            type: 'item',
            name: 'Target Customer List',
            key: 'prospect-tables',
            route: '/prospect/prospect-tables/details',
            icon: <ListIcon fontSize="small" />,
            component: <ProspectListTable />,
          },
        ],
      },
      {
        type: 'collapse',
        name: 'Schedule Meetings',
        key: 'meeting',
        icon: <VideoCallIcon fontSize="medium" />,
        collapse: [
          {
            type: 'item',
            name: 'Create Meeting',
            key: 'create-meeting',
            route: '/meeting/create-meeting/details',
            icon: <EventNoteIcon fontSize="small" />,
            component: <CreateMeeting />,
          },
          {
            type: 'item',
            name: 'Meeting List',
            key: 'meeting-tables',
            route: '/meeting/meeting-tables/details',
            icon: <CalendarViewDayIcon fontSize="small" />,
            component: <MeetingTable />,
          },
        ],
      },
      {
        type: 'collapse',
        name: 'Opportunities',
        key: 'opportunity',
        icon: <BusinessIcon fontSize="medium" />,
        collapse: [
          {
            type: 'item',
            name: 'Create Opportunity',
            key: 'create-opportunity',
            route: '/opportunity/create-opportunity/details',
            icon: <AddBusinessIcon fontSize="small" />,
            component: <CreateOpportunity />,
          },
          {
            type: 'item',
            name: 'Opportunity List',
            key: 'opportunity-tables',
            route: '/opportunity/opportunity-tables/details',
            icon: <TimelineIcon fontSize="small" />,
            component: <OpportunityTable />,
          },
        ],
      },
      {
        type: 'collapse',
        name: 'Sales Lead',
        key: 'sales-lead',
        icon: <VideoCallIcon fontSize="medium" />,
        collapse: [
          {
            type: 'item',
            name: 'Create Sales Lead',
            key: 'create-sales-lead',
            route: '/sales-lead/create-sales-lead/details',
            icon: <EventNoteIcon fontSize="small" />,
            component: <CreateSalesLead />,
          },
          {
            type: 'item',
            name: 'Sales Lead List',
            key: 'sales-lead-tables',
            route: '/sales-lead/sales-lead-tables/details',
            icon: <CalendarViewDayIcon fontSize="small" />,
            component: <SalesLeadTable />,
          },
          {
            name: "Sales Lead Dashboard",
            key: "sales-lead-dashboard",
            route: "/sales-lead/sales-lead-dashboard",
            component: <SalesLeadDashboard />,
          },
        ],
      },
      {
        type: 'collapse',
        name: 'Competitors',
        key: 'competitor',
        icon: <BusinessCenterIcon fontSize="medium" />,
        collapse: [
          {
            type: 'item',
            name: 'Create Competitor',
            key: 'create-competitor',
            route: '/competitor/create-competitor/details',
            icon: <AddBusinessIcon fontSize="small" />,
            component: <CreateCompetitor />,
          },
          {
            type: 'item',
            name: 'Competitor List',
            key: 'competitor-tables',
            route: '/competitor/competitor-tables/details',
            icon: <ListIcon fontSize="small" />,
            component: <CompetitorTable />,
          },
        ],
      },
    ],
  },
  {
    type: "collapse",
    name: "Global Partners",
    key: "global-agent",
    icon: <PublicIcon fontSize="medium" />,
    collapse: [
      {
        name: "Create Global Partner",
        key: "create-global-agent",
        route: "/global-agent/create-global-agent/details",
        component: <CreateGlobalAgent />,
      },
      {
        name: "Global Partner List",
        key: "global-agent-tables",
        route: "/global-agent/global-agent-tables/details",
        component: <GlobalAgentTable />,
      },
      {
        name: "GP Dashboard ",
        key: "global-agent-dashboard",
        route: "/global-agent/global-agent-dashboard",
        component: <GlobalAgentDashboard />
      },
    ],
  },
  {
    type: "collapse",
    name: "Supplier Management",
    key: "service-provider",
    subject: "users",
    icon: <LocalShippingIcon fontSize="medium" />,
    collapse: [
      {
        name: "Create Service Provider",
        key: "create-service-provider",
        route: "/service-provider/create-service-provider/details",
        component: <CreateServiceProvider />,
      },
      {
        name: "Service Provider List",
        key: "service-provider-tables",
        route: "/service-provider/service-provider-tables/details",
        component: <ServiceProviderTable />,
      },
      {
        name: "SP Dashboard ",
        key: "service-provider-dashboard",
        route: "/service-provider/service-provider-dashboard",
        component: <ServiceProviderDashboard />
      },
    ],
  },
  {
    type: "collapse",
    name: "Quoting Management",
    key: "quoting-tool",
    icon: <Icon fontSize="medium">payments</Icon>,
    collapse: [
      {
        name: "Create Quoting",
        key: "create-quoting-tool",
        route: "/quoting-tool/create-quoting-tool/details",
        component: <CreateQuotingTool />,
      },
      {
        name: "Quoting Tables",
        key: "quoting-tool-tables",
        route: "/quoting-tool/quoting-tool-tables/details",
        component: <QuotingToolTable />,
      },
      {
        name: "Quoting Dashboard",
        key: "quoting-tool-dashboard",
        route: "/quoting-tool/quoting-tool-dashboard",
        component: <QuotingDashboard />,
      },
    ],
  },
  {
    type: "collapse",
    name: "RFQ",
    key: "rfq",
    icon: <Icon fontSize="medium">description</Icon>,
    collapse: [
      {
        name: "Create RFQ",
        key: "rfq-list",
        route: "/rfq/details",
        component: <Rfq />,
      },
      {
        name: "RFQ Dashboard",
        key: "rfq-dashboard",
        route: "/rfq-dashboard/details",
        component: <RfqDashboard />,
      },
    ],
  },

  {
    type: "collapse",
    name: "Spot Quoting Tower",
    key: "spot-quoting-tool",
    icon: <Icon fontSize="medium">money</Icon>,
    collapse: [
      {
        name: "Spot Quote",
        key: "spot-create-quoting-tool",
        route: "/spot-quoting-tool/create-spote-quoting-tool/details",
        component: <CreateSpotQuotingTool />,
      },
      {
        name: "Cost Management",
        key: "spot-quoting-tool-tables",
        route: "/spot-quoting-tool/spot-quoting-tool-tables/details",
        component: <SpotQuotingToolTable />,
      },
    ],
  },

  {
    type: "collapse",
    name: "Trade Compliance",
    key: "trade-compliance",
    icon: <FactCheckIcon fontSize="medium" />,
    route: "/trade-compliance",
    noCollapse: true,
  },

  // Menüde gösterilmez (type: "collapse" değil) — diğer sayfalardan navigate() ile ulaşılır
  {
    key: "connect-mbl",
    route: "/shipping-order/connect-mbl",
    component: <ConnectMBL />,
  },

];

export default routes;
